<template>
  <!-- Modal -->
  <div class="modal fade" id="infoDetrazione" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="infoDetrazione" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modalInfo">
      <div class="modal-content">
        <div class="modal-header">
          <img class="aereoPopup" src="https://www.rimborsoalvolo.it/cresources/outform/images/aereoPopup.svg">
        </div>
        <div class="modal-body">
          <br>
          <h2>Avviso importante.</h2>
          <p style="text-align: justify">
            <br>
            Purtroppo, <b>riguardo esclusivamente alle pratiche Ryanair e EasyJet</b>,  non possiamo più fornire il servizio a costo zero, come abbiamo sempre fatto da 15 anni.
            <br>
            Il nostro introito deriva esclusivamente dalle spese legali riconosciute dalle compagnie aeree per il lavoro svolto, il quale, in questi casi specifici, non viene riconosciuto.
            <br>
            <br>
            Per permetterci quindi di continuare ad offrire il nostro servizio a costo zero senza dover imporre una percentuale fissa a tutti, ci troviamo costretti a trattenere il 30% del risarcimento <b>solo per le pratiche Ryanair e EasyJet e solo per quelle che si concludono in via stragiudiziale</b>. Questo ci permette di coprire le spese sostenute per portare avanti il vostro caso e farvi ottenere quanto vi spetta, con l'auspicio che tale misura sia solamente temporanea.<br>
            <br>
            <b>IMPORTANTE: nel caso in cui dovessimo procedere davanti al Giudice di Pace, NON sarà richiesta alcuna percentuale, poiché ogni importo dovuto a RimborsoalVolo.it sarà liquidato direttamente dalla compagnia aerea secondo le disposizioni stabilite dal Giudice.</b>
            <br>
            <br>
            Grazie per la vostra comprensione e fiducia nel nostro operato.
          </p>
          <br>
          <div class="row">
            <div class="col-md-4">
              <button type="submit" style="font-size: 15px;" class="btn styleBtn2 mb-3" @click.prevent="callRifiutaCondizioni">NON VOGLIO PROSEGUIRE</button>
            </div>
            <div class="col-md-4">

            </div>
            <div class="col-md-4">
              <button type="submit" class="btn styleBtn mb-3" @click.prevent="callAccettaCondizioni">ACCETTO</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script setup>
  const emit = defineEmits(['condizioniAccettate','condizioniRifiutate']);
  const callAccettaCondizioni = () => {
      emit('condizioniAccettate');
  }
  const callRifiutaCondizioni = ()=>{
    emit('condizioniRifiutate');
  }
</script>
<script>
export default {
  name: "PopupAvvisoDetrazione"
}
</script>

<style scoped>

</style>